<template>
<div class="divFormMailTel">
  <!-- <h4 class="titre">Si t'as pas de phone-tel mec laisse moi ton e-mail</h4> -->
  <h4 class="titre">Ne perdons pas le contact</h4>
  <div class="form">
    <h5><i v-if="!noEmojis" class="em em-email" aria-role="presentation" aria-label="ENVELOPE" />E-mail</h5>
    <input v-model="client.mailClient" type="email" id="mailClient" placeholder="votre@email.com">
    <h5><i v-if="!noEmojis" class="em em-iphone" aria-role="presentation" aria-label="MOBILE PHONE"></i>Téléphone portable</h5>
    <input name="telClient" v-model="client.telClient" type="tel" id="telClient" placeholder="06 12 34 56 78" maxlength="14">
    <p class="preventionText">Ces informations ne seront en aucun cas transmises à un tiers. Elles nous servirons uniquement en cas de problèmes techniques.</p>
    <div class="denySendData">
      <input v-model="client.denySendData" type="checkbox" id="checkbox">
      <label for="checkbox">Je ne souhaite pas être contacté</label>
    </div>
  </div>
  <NavBar :next="true" :prev="true" />
</div>
</template>

<script>
import NavBar from '@/components/OrderBooth/NavBar'
import axios from 'axios'
import JQuery from 'jquery'
let $ = JQuery
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

export default {
  data() {
    return {
      client: {
        mailClient: this.$store.getters.reservation_client.client.mail,
        telClient: this.$store.getters.reservation_client.client.telPortable,
        denySendData: false,
      },
      noEmojis: this.$store.getters.reservation_client.noEmojis,
    }
  },
  mounted: function() {
    $('html,body').animate({scrollTop: 0}, 'slow');

    let telEl = document.querySelector('#telClient')
    telEl.addEventListener('keyup', (e) => {
      let val = e.target.value;
      e.target.value = val
        .replace(/\D/g, '')
        .replace(/(\d{1,2})(\d{1,2})?(\d{1,2})?(\d{1,2})?(\d{1,2})?/g, function(txt, un, deux, trois, quatre, cinq) {
          if (cinq) {
            return `${un} ${deux} ${trois} ${quatre} ${cinq}`
          } else if (quatre) {
            return `${un} ${deux} ${trois} ${quatre}`
          } else if (trois) {
            return `${un} ${deux} ${trois}`
          } else if (deux) {
            return `${un} ${deux}`
          } else if (un) {
            return `${un}`
          }
      });
    })
  },
  computed: {
    GOnextStep: function () {
      if (this.client.mailClient && this.client.telClient) {
        return true;
      }
      return false;
    }
  },
  methods: {
    nextStep() {
      if (!this.client.denySendData) {
        if (!this.$store.getters.reservation_client.pre_reservation) {
          if (this.client.mailClient || this.client.telClient) {
            let self = this;
            axios.post('https://preprod.api.defipix.fr/pre_reservation', {
              date: this.$store.getters.reservation_client.evenement.date,
              address: this.$store.getters.reservation_client.evenement.adresse,
              booth: this.$store.getters.reservation_client.borne.name,
              mail: this.client.mailClient,
              phone: this.client.telClient,
            })
            .then(function (response) {
              self.$store.commit('RCsetPreReservation', response.data.id);
            });
          }
          this.$store.commit('RCsetMailTel', this.client);
        }
      }
    }
  },
  components: {
    NavBar,
    'v-popover': VPopover,
  },
  directives: {
    'tooltip': VTooltip,
    'close-popover': VClosePopover
  },
}

</script>

<style scoped>
.divFormMailTel {
    margin-top: 2em;
    padding-top: 2em;
    background-color: rgb(248, 248, 248);
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px #aaa;
    background-color: #25327B;
}

h5 {
  color: #fff;
  margin: .5em 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

input {
  text-align: center;
}

.titre {
  padding: unset;
}

.form {
    width: 25em;
    margin: auto;
    text-align: center;
    padding: 1.5em;
}

#mailClient, #telClient {
    margin: .5em 0;
}

button {
    margin-top: 1em;
    width: 40%;
}

#checkbox {
  margin: 0 .5em .5em 0;
}

.preventionText {
  color: #fff;
  font-size: 12px;
  color: rgb(202, 202, 202);
}

.denySendData {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: rgb(202, 202, 202);
  font-size: 12px;
}

@media only screen and (max-width: 450px) {
  .form {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderBooth/Contact.vue